import queries from '@apis/queries';
import StampApi from '@apis/stamp/StampApi';
import { GetStampHistoriesParams } from '@models/stamp';
import { useInfiniteQuery } from '@tanstack/react-query';
import { getFlattenPageResponse, getNextPageParam } from '@utils/slice';

function useStampHistories(shopId: string) {
    const params: Omit<GetStampHistoriesParams, 'page'> = {
        size: 20,
    };
    const queryInfo = useInfiniteQuery({
        queryKey: queries.stamps.history(shopId, params).queryKey,
        queryFn: ({ pageParam }) => StampApi.getStampHistories(shopId, {
            ...params, page: pageParam,
        }),
        initialPageParam: 0,
        getNextPageParam,
    });
    const histories = getFlattenPageResponse(queryInfo);
    return {
        ...queryInfo,
        histories,
    };
}

export default useStampHistories;
